import React from 'react';
import { usePageTranslations } from '../hooks/useTranslation.js';
import { brandText } from '../components/BrandText.jsx';
import Footer from '../components/Footer.jsx';

// The legal notice in rows: the topic on the left, the facts on the right.
const ImpressumPage = () => {
  const t = usePageTranslations('impressum');
  const email = t.contactEmail || 'info@paioneer.eu';

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="site-hero__copy">
            <h1 className="site-title">{t.title}</h1>
            <p className="site-lead">{t.subtitle}</p>
          </div>
        </section>

        <section className="legal-section">
          <h2 className="legal-section__title">{t.serviceProvider}</h2>
          <div className="legal-section__body">
            <p className="legal-section__name">{brandText(t.providerData.name)}</p>
            {t.providerData.title && <p>{t.providerData.title}</p>}
            {t.providerData.register && <p>{t.providerData.register}</p>}
          </div>
        </section>

        <section className="legal-section">
          <h2 className="legal-section__title">{t.contactTitle}</h2>
          <div className="legal-section__body">
            <h3>{t.addressLabel}</h3>
            <p>
              {t.placeholders.street}<br />
              {t.placeholders.postalCode} {t.placeholders.city}<br />
              {t.placeholders.country}
            </p>
            <h3>{t.contactLabel}</h3>
            <p><a href={`mailto:${email}`}>{brandText(email)}</a></p>
          </div>
        </section>

        <section className="legal-section">
          <h2 className="legal-section__title">{t.professionalTitle}</h2>
          <div className="legal-section__body">
            <h3>{t.professionLabel}</h3>
            <p>{t.professionValue}</p>
            <h3>{t.businessTypeLabel}</h3>
            <p>{t.businessTypeValue}</p>
          </div>
        </section>

        <section className="legal-section">
          <h2 className="legal-section__title">{t.liabilityTitle}</h2>
          <div className="legal-section__body">
            <h3>{t.contentLiabilityTitle}</h3>
            <p>{t.contentLiability}</p>
            <h3>{t.linkLiabilityTitle}</h3>
            <p>{t.linkLiability}</p>
          </div>
        </section>

        <section className="legal-section">
          <h2 className="legal-section__title">{t.copyrightTitle}</h2>
          <div className="legal-section__body">
            <p>{t.copyright}</p>
          </div>
        </section>

        <p className="legal-note">{t.legalFramework}</p>
      </main>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
